'use client';

import { HasuraStorageClient } from '@nhost/hasura-storage-js';
import { createContext, useEffect } from 'react';
import { useAccessToken } from '../../auth/hooks/useAccessToken';

export const StorageContext = createContext<HasuraStorageClient>(
  {} as HasuraStorageClient,
);

if (!process.env.REACT_APP_STORAGE_URL) {
  throw new Error('REACT_APP_STORAGE_URL environment variable is not defined');
}

const storageUrl = process.env.REACT_APP_STORAGE_URL;

function makeClient() {
  return new HasuraStorageClient({
    url: storageUrl,
  });
}

export function StorageProvider({ ...props }: {children: React.ReactNode}) {
  const storage = makeClient();
  const token = useAccessToken();
  useEffect(() => {
    storage.setAccessToken(token || undefined);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);
  return (
    <StorageContext.Provider value={storage}>
      {props.children}
    </StorageContext.Provider>
  );
}
